export const eventHandlers = {
  SHOPPING_CART_EMPTY_PAGE_VIEW: 'SHOPPING_CART_EMPTY_PAGE_HIT',
};
